import React from "react";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import ls from "local-storage";
import Moment from "react-moment";

import * as CONFIG from "./_config";

const axios = require("axios");

class Coupons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      departments: [],
      coupanlist: null,
      show: false,
      productdata: [],
      disableaddtocart: true,
    };
    // this.AddtoCart = this.AddtoCart.bind(this);
  }

  componentDidMount() {
    ls.set("redirectTo", window.location.href);
    this.Departments();
  }

  Departments() {
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : CONFIG.DATA.GUEST_TOKEN_USER;
    if (!UserToken) {
      this.setState({ departments: [], coupanlist: [] });
      return;
    }

    const data = new FormData();
    data.append("method", "POST");
    //data.append('apiurl', `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetCategoriesForCoupons/${UserToken}`);
    const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetCategoriesForCoupons/${UserToken}`;
    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        if (res.data.GetProductCategories) {
          let department_list = res.data.GetProductCategories;
          var user_dept = department_list.filter(
            (a) => a.ProductCategoryId >= 10000
          );
          user_dept.sort((a, b) => a.ProductCategoryId < b.ProductCategoryId);

          var generic_dept = department_list.filter(
            (a) => a.ProductCategoryId < 10000
          );
          generic_dept.sort((a, b) =>
            a.ProductCategoryName.localeCompare(b.ProductCategoryName)
          );
          var merged_list = [...user_dept, ...generic_dept];

          this.setState({ departments: merged_list });
        } else {
          this.setState({ departments: [] });
        }
        this.Coupanlist();
      })
      .catch(function (response) {
        console.log(response);
      });
  }

  handleClick(e, ProductCategoryId) {
    e.stopPropagation();

    this.setState({ coupanlist: [], ProductCategoryId: ProductCategoryId });
    setTimeout(() => {
      this.Coupanlist(ProductCategoryId);
      ls.set("redirectTo", window.location.href);
    });
  }

  handleClose = () => {
    this.setState({ show: false });
  };
  handleShow = (e, index) => {
    e.preventDefault();
    // console.log('data',data);
    this.setState({ show: true });
    this.setState({ product_index: index });
    setTimeout(() => {
      //console.log(this.state);
    }, 100);
  };

  Coupanlist(ProductCategoryId = 0) {
    this.setState({ coupanlist: null });
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : CONFIG.DATA.GUEST_TOKEN_USER;
    let category = this.props.match.params.id || "";
    category = category.replace("#", "");

    if (
      this.props.history.location.hash !== "" &&
      this.props.history.location.hash !== "#"
    ) {
      let hash = this.props.history.location.hash;
      if (hash.length > 10) {
        var hashlist = hash.split("/");
        if (hashlist.length > 3) {
          // "#/beachers/coupons/deals-of-the-week".
          category = hashlist[3];
        }
      }
    }

    if (category !== "") {
      if (category === "all") {
        ProductCategoryId = 0;
      } else {
        let dept = this.state.departments.find(
          (d) =>
            d.ProductCategoryName.replace(/\s/g, "-")
              .replace(/\//g, "_")
              .toLowerCase() === category
        );
        // console.log(category, dept);
        if (dept) {
          ProductCategoryId = dept.ProductCategoryId;
        }
      }
    }

    const data = new FormData();
    data.append("method", "POST");
    //data.append('apiurl', `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetDetailsForCoupons/${ProductCategoryId}/${UserToken}/0`);
    const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetDetailsForCoupons/${ProductCategoryId}/${UserToken}/0`;
    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })

      .then((res) => {
        if (ProductCategoryId > 0) {
          //console.log(res.data.Specials);return;
          this.setState({
            coupanlist: res.data.Specials,
            ProductCategoryId: ProductCategoryId,
          });
        } else if (ProductCategoryId === 0) {
          this.setState({
            coupanlist: (res.data && res.data.Specials) || [],
            ProductCategoryId: ProductCategoryId,
            total_coupan:
              (res.data && res.data.Specials && res.data.Specials.length) || 0,
          });
        }
        //this.setState({ disableaddtocart:false});
      })
      .catch(function (response) {
        console.log(response);
      });
  }

  AddtoCart = async (event, index) => {
    event.preventDefault();
    event.persist();

    if (!ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)) {
      toast.info("Please login to add item to cart!");
      let redirectToPath = window.location.pathname;

      if (window.location.hash !== "")
        redirectToPath = redirectToPath + window.location.hash;

      // console.log(window.location, window.location.hash, redirectToPath);
      ls.set("redirectTo", window.location.href);
      this.props.history.push("/login");
      return false;
    }

    //this.setState({ disableaddtocart:true});

    var button_span = null;
    if (event.target && event.target.tagName.toLowerCase() === "span") {
      button_span = document.getElementById(event.target.id);
    } else if (
      event.target &&
      event.target.tagName.toLowerCase() === "button"
    ) {
      var button = document.getElementById(
        event.target.id
      ); /* id is unique by definition! */
      var spans = button.getElementsByTagName("span");
      if (spans) button_span = spans[0];
    }

    if (button_span === null) {
      return false;
    }

    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : CONFIG.DATA.GUEST_TOKEN_USER;

    // console.log('deaild',details);
    if (index !== null && index > -1) {
      // var product = JSON.parse(details,true)
      var coupanlist = this.state.coupanlist;
      var product = coupanlist[index];

      this.setState({ show: false });
      // console.log('productproduct',product);

      const data = new FormData();

      if (product) {
        if (button_span.getAttribute("data-action") !== "remove") {
          //if (!product.IsInCart) {
          const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/SaveMyCart`;
          data.append("method", "POST");
          //data.append('apiurl', `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/SaveMyCart`);
          data.append(
            "OfferId",
            product.SSNewsId ? product.SSNewsId : product.SSNewsId
          );
          data.append("CategoryId", product.NewsCategoryId);
          data.append(
            "MemberNumber",
            ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).MemberNumber
          );
          data.append("UserFirstName", product.CustomerName);
          data.append("NCRPromotionCode", product.NCRPromotionCode);
          data.append("IsInNCRImpressions", product.IsInNCRImpressions);
          data.append("Title", product.Title);
          data.append("Details", product.Details);
          data.append("Amount", product.Amount);
          data.append("ProductName", product.ProductName);
          data.append("ValidFrom", product.ValidFromDate);
          data.append("ExpiresOn", product.ExpiresOn);
          data.append("UPC", "");
          data.append("UserToken", UserToken);

          var object = {};
          data.forEach((value, key) => (object[key] = value));
          var jsonData = JSON.stringify(object);

          axios
            .post(apiurl, jsonData, {
              headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
            })
            .then((res) => {
              if (
                res &&
                res.data &&
                res.data.ErrorMessage &&
                res.data.ErrorMessage.ErrorCode !== null &&
                res.data.ErrorMessage.ErrorCode === 1
              ) {
                this.Coupanlist();

                toast.info("Item added to cart.", { autoClose: 2000 });
                this.Notification("plus");

                product.IsInCart = true;

                var button_span = null;
                if (
                  event.target &&
                  event.target.tagName.toLowerCase() === "span"
                ) {
                  button_span = document.getElementById(event.target.id);
                } else if (
                  event.target &&
                  event.target.tagName.toLowerCase() === "button"
                ) {
                  var button = document.getElementById(
                    event.target.id
                  ); /* id is unique by definition! */
                  var spans = button.getElementsByTagName("span");
                  if (spans) button_span = spans[0];
                }

                if (button_span !== null) {
                  button_span.innerHTML = CONFIG.DATA.REMOVE_FROM_CART_TEXT;
                  button_span.setAttribute("data-action", "remove");

                  // document.getElementById('add_to_cart_shape_' + index).style.display = 'block'
                }
              } else if (
                res &&
                res.data &&
                res.data.ErrorMessage &&
                res.data.ErrorMessage.ErrorDetails !== null
              ) {
                toast.info(res.data.ErrorMessage.ErrorDetails, {
                  autoClose: 2000,
                });
              }
            })
            .catch(function (response) {
              console.log(response);
            });
        } else {
          const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/RemoveFromCart/${product.SSNewsId}/${UserToken}`;
          data.append("method", "POST");
          //data.append('apiurl', `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/RemoveFromCart/${product.SSNewsId}/${UserToken}`);
          var object = {};
          data.forEach((value, key) => (object[key] = value));
          var jsonData = JSON.stringify(object);

          axios
            .post(apiurl, jsonData, {
              headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
            })
            .then((res) => {
              // console.log('resresres210', res);
              if (
                res &&
                res.data &&
                res.data.ErrorMessage &&
                res.data.ErrorMessage.ErrorCode !== null &&
                res.data.ErrorMessage.ErrorCode === 1
              ) {
                this.Coupanlist();
                toast.warn("Item removed from cart.", { autoClose: 2000 });
                this.Notification("minus");

                product.IsInCart = false;

                var button_span = null;
                if (
                  event.target &&
                  event.target.tagName.toLowerCase() === "span"
                ) {
                  button_span = document.getElementById(event.target.id);
                } else if (
                  event.target &&
                  event.target.tagName.toLowerCase() === "button"
                ) {
                  var button = document.getElementById(
                    event.target.id
                  ); /* id is unique by definition! */
                  var spans = button.getElementsByTagName("span");
                  if (spans) button_span = spans[0];
                }

                if (button_span !== null) {
                  button_span.innerHTML = CONFIG.DATA.ADD_TO_CART_TEXT;
                  button_span.setAttribute("data-action", "add");

                  //document.getElementById('add_to_cart_shape_' + index).style.display = 'none'
                }
              } else if (
                res &&
                res.data &&
                res.data.ErrorMessage &&
                res.data.ErrorMessage.ErrorDetails !== null
              ) {
                toast.info(res.data.ErrorMessage.ErrorDetails, {
                  autoClose: 2000,
                });
              }
            })
            .catch(function (response) {
              console.log(response);
            });
        }
      }
    }
  };

  Notification(type) {
    var item_count = document
      .getElementById("Notificationcount")
      .getElementsByTagName("span")[0].innerHTML;
    if (type === "plus") {
      item_count++;
    } else {
      item_count--;
    }
    if (item_count !== null && !isNaN(item_count)) {
      item_count = item_count || 0;

      document.getElementById("Notificationcount").innerHTML =
        '<img src="/assets/images/icons/shopingcarticons.png"><span class="badge">' +
        item_count +
        "</span>";
      document.getElementById("tip-cart").innerHTML =
        item_count > 0
          ? "Click to view your shopping cart"
          : "You have no items in your shopping cart";
    }
  }

  render() {
    var IsLoggedIn = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? true
      : false;
    var index = this.state.product_index;
    var productdata =
      index !== null && index > -1 && this.state.coupanlist
        ? this.state.coupanlist[index]
        : null;
    var CurrentProductCategoryId = this.state.ProductCategoryId;

    let AppsAvailable =
      CONFIG.DATA.APP_URL_ANDROID !== "" || CONFIG.DATA.APP_URL_IOS !== "";

    var IsLewisFood = "";

    if (
      CONFIG.DATA.BACKEND_HOST === "lewisfood" ||
      CONFIG.DATA.BACKEND_HOST === "haysmarketcoupons_1"
    ) {
      var IsLewisFood = CONFIG.DATA.BACKEND_HOST;
    }

    const total_coupons_count = this.state.departments
      .filter((each) => each.ProductCategoryId !== 10001)
      .reduce((total, item) => total + item.NoOfCoupons, 0);

    const department = this.state.departments.map((value, index) => {
      if (IsLoggedIn || value.ProductCategoryId !== 10001) {
        // && value.ProductCategoryId !== 10002)){
        return (
          <li key={index} className="all_department font-size-17px">
            <Link
              style={
                CurrentProductCategoryId === value.ProductCategoryId
                  ? { color: CONFIG.DATA.LOGO_COLOR, fontWeight: "bold" }
                  : { color: "#6c6a6a" }
              }
              id="all_0"
              className={`all_0 anchor coupens`}
              to={
                "/coupons/" +
                value.ProductCategoryName.replace(/\s/g, "-").toLowerCase()
              }
              onClick={(e) => this.handleClick(e, value.ProductCategoryId)}
              data-id="0"
            >
              <span className="vc_tta-title-text">
                {value.ProductCategoryName}
              </span>
              <span className="coupon_count"> ({value.NoOfCoupons})</span>
            </Link>
          </li>
        );
      }
    });

    const coupanlist =
      this.state.coupanlist &&
      this.state.coupanlist.map((value, index) => {
        var productInCart = value.IsInCart;
        var productDetails = value.Details;
        // console.log(productDetails.length);
        // if(productDetails.length > 30) {
        //     productDetails = productDetails.substring(0,15) + '...';
        // }
        // var productExpiresOn = value.ExpiresOn;
        // var productImagePath = value.ImagePath;
        var productNewsCategoeyId = value.NewsCategoryId;
        // var productPLUCode = value.PLUCode;
        // var nowDate = new Date(parseInt(productExpiresOn.substr(6)));
        // if(value.CouponId){
        //     var productID = value.CouponId;
        // }
        // else{
        //     var productID = value.SSNewsId;
        // }
        // console.log(nowDate);

        var productTitle = value.Title;
        if (productNewsCategoeyId === 4) {
          productTitle = value.ProductName;
        }

        var productTitleShow = productTitle;
        if (productTitle != null && productTitle.length > 35) {
          productTitleShow = productTitle.substring(0, 35) + "...";
        }

        // var page = (index+1);

        var cartTitle = CONFIG.DATA.COUPON_CLIP_BUTTON_LABEL
          ? CONFIG.DATA.COUPON_CLIP_BUTTON_LABEL
          : CONFIG.DATA.ADD_TO_CART_TEXT;
        if (productInCart === true) {
          cartTitle = CONFIG.DATA.REMOVE_FROM_CART_TEXT;
        }

        return (
          <div
            key={index}
            className="coupons item-col col-md-3 col-full-hd product type-product status-publish has-post-thumbnail product_cat-dress product_cat-drink product_cat-fashion first instock sale shipping-taxable purchasable product-type-simple"
            style={{ minWidth: "221px" }}
          >
            <div className="product-wrapper" title={productTitleShow}>
              <div className="gridview">
                <div className="list-col4 ">
                  <div className="red-corner">{/*<!-- -->*/}</div>
                  {value.PLUCode === "100%" ? (
                    <div className="free corner-text">
                      <br />
                      Free!&nbsp;&nbsp;{" "}
                      <span
                        style={{ fontSize: "15px", display: "block" }}
                      ></span>
                    </div>
                  ) : (
                    <div className="free corner-text">
                      Save{" "}
                      <span style={{ fontSize: "15px", display: "block" }}>
                        {value.PLUCode}
                      </span>
                    </div>
                  )}

                  <div
                    id={`add_to_cart_shape_${index}`}
                    className="add_to_cart_shape coupons"
                    style={{ display: productInCart ? "block" : "none" }}
                  >
                    <img
                      alt="Already in Cart"
                      loading="lazy"
                      src="/assets/images/shape_1.png"
                    />
                  </div>

                  <div className="product-image">
                    <Link
                      to="#"
                      className="woocommerce-LoopProduct-link woocommerce-loop-product__link"
                      onClick={(e) => {
                        this.handleShow(e, index);
                      }}
                    >
                      <div className="product-image-div" style={{}}>
                        <img
                          loading="lazy"
                          width="300"
                          height="300"
                          src={value.ImagePath}
                          className="primary_image"
                          alt="Coupon"
                          title={productTitleShow}
                          style={{ height: "100%", objectFit: "contain" }}
                        />
                      </div>
                    </Link>
                  </div>
                  <div className="quickviewbtn" style={{ zIndex: "99" }}>
                    <Link
                      to="#"
                      onClick={(e) => {
                        this.handleShow(e, index);
                      }}
                      className="quickview1 DFDF"
                      href="#"
                      title={productTitleShow}
                    >
                      Quick View
                    </Link>
                  </div>
                </div>
                <div className="list-col8 ">
                  {/*<h2 className="product-name"><a href="#">SAVE {value.PLUCode}</a></h2>*/}
                  <h4 className="product-name font-size-15px ">
                    <Link to="#">{productTitleShow}</Link>
                  </h4>
                  <div className="ratings"></div>
                  <div className="price-box">
                    <div
                      className="product-name product-desc font-size-15px "
                      style={{ fontSize: "13px" }}
                    >
                      <p>{productDetails}</p>
                    </div>
                  </div>
                  <ul className="actions">
                    <li className="add-to-cart">
                      <button
                        onClick={(e) => {
                          this.AddtoCart(e, index);
                        }}
                        rel="nofollow"
                        id={`add_to_cart_${index}`}
                        className="quickview btn btn-theme add_to_cart"
                      >
                        <span
                          id={`span_add_to_cart_${index}`}
                          data-action={productInCart ? "remove" : "add"}
                          className="title-cart"
                        >
                          {cartTitle}
                        </span>
                      </button>
                    </li>
                  </ul>
                  <div className="count-down">
                    <div className="countbox hastime" data-time="2020/01/23">
                      <span className="timebox day">
                        146<strong>days</strong>
                      </span>
                      <span className="timebox hour">
                        11<strong>hours</strong>
                      </span>
                      <span className="timebox minute">
                        41<strong>mins</strong>
                      </span>
                      <span className="timebox second">
                        16<strong>secs</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        );
      });

    return (
      <div>
        <div className="cpn">
          {CONFIG.DATA.THEME === 1 ? (
            <div className="main-container default-page pt-2 mt-2  ">
              <div className="title-breadcrumb">
                <div className="container">
                  <header className="entry-header">
                    <h1 className="entry-title">Coupons</h1>
                  </header>
                  <div className="breadcrumbs">
                    <a href={CONFIG.DATA.BASEPATH}>Home</a>
                    <span className="separator">/</span>
                    <a href="/coupons" title="Coupons">
                      {" "}
                      Coupons
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              className={`main-container default-page ${
                IsLewisFood ? `` : `pt-5 mt-5`
              }`}
            ></div>
          )}
        </div>

        <div>
          <div className="container">
            <div className="main-container default-page">
              <div className={`row ${IsLewisFood ? `lewis_row` : ` `}`}>
                {!IsLewisFood ? (
                  <div className="col-md-3 ">
                    {CONFIG.DATA.BACKEND_HOST === "foodbazaar" ||
                    CONFIG.DATA.BACKEND_HOST === "marketplacewatertown" ? (
                      <>
                        <div style={{ textAlign: "left" }}>
                          {AppsAvailable ? (
                            <span
                              to="#"
                              className="mr-3"
                              style={{ color: "#000" }}
                            >
                              Download Our Apps{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        {CONFIG.DATA.APP_URL_ANDROID !== "" ? (
                          <a
                            href={CONFIG.DATA.APP_URL_ANDROID}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mr-1"
                          >
                            <img
                              loading="lazy"
                              alt="Download from Google Play"
                              title="Download from Google Play"
                              src="/assets/images/icons/google-play-300x300.png"
                              style={{
                                width: "65px",
                                padding: "2px",
                                float: "left",
                                marginLeft: "-5px",
                              }}
                            />
                          </a>
                        ) : (
                          ""
                        )}
                        {CONFIG.DATA.APP_URL_IOS !== "" ? (
                          <a
                            href={CONFIG.DATA.APP_URL_IOS}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mr-3"
                          >
                            <img
                              loading="lazy"
                              alt="Download from App Store"
                              title="Download from App Store"
                              src="/assets/images/icons/appstore-2-300x300.jpg"
                              style={{
                                width: "65px",
                                padding: "2px",
                                float: "left",
                              }}
                            />{" "}
                          </a>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      ""
                    )}
                    {CONFIG.DATA.BACKEND_HOST === "foodbazaar" ? (
                      <div
                        className="coupon-dept"
                        style={{ textAlign: "left", marginTop: "135px" }}
                      >
                        <h3 style={{ marginBottom: "25px" }}>Departments</h3>
                        <div className="department_list">
                          <ul
                            className="department_list"
                            style={{ listStyle: "none", paddingLeft: "0px" }}
                          >
                            <li className="all_department font-size-17px">
                              <Link
                                // to="#"
                                style={
                                  CurrentProductCategoryId > 0
                                    ? { color: "#6c6a6a" }
                                    : {
                                        color: CONFIG.DATA.LOGO_COLOR,
                                        fontWeight: "bold",
                                      }
                                }
                                id="all_0"
                                className="all_0 anchor coupens"
                                to="/coupons/all"
                                data-id="0"
                                onClick={(e) => this.handleClick(e, 0)}
                              >
                                <span className="vc_tta-title-text">
                                  {"All Coupons " +
                                    (this.state.total_coupan > 0
                                      ? "(" + this.state.total_coupan + ")"
                                      : "")}
                                </span>
                              </Link>
                            </li>
                            {department}
                          </ul>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="coupon-dept"
                        style={{ textAlign: "left" }}
                      >
                        <h3 style={{ marginBottom: "25px" }}>Departments</h3>
                        <div className="department_list">
                          <ul
                            className="department_list"
                            style={{ listStyle: "none", paddingLeft: "0px" }}
                          >
                            <li className="all_department font-size-17px">
                              <Link
                                // to="#"
                                style={
                                  CurrentProductCategoryId > 0
                                    ? { color: "#6c6a6a" }
                                    : {
                                        color: CONFIG.DATA.LOGO_COLOR,
                                        fontWeight: "bold",
                                      }
                                }
                                id="all_0"
                                className="all_0 anchor coupens"
                                to="/coupons/all"
                                data-id="0"
                                onClick={(e) => this.handleClick(e, 0)}
                              >
                                <span className="vc_tta-title-text">
                                  {"All Coupons " +
                                    (this.state.total_coupan > 0
                                      ? "(" + total_coupons_count + ")"
                                      : "")}
                                </span>
                              </Link>
                            </li>
                            {department}
                          </ul>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )}
                {productdata ? (
                  <Modal
                    show={this.state.show}
                    size="lg"
                    dialogClassName="modal-60w"
                    centered
                    onHide={this.handleClose}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>{productdata.ProductName}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="row">
                        <div className=" col-md-3">
                          <img
                            alt={productdata.ProductName}
                            loading="lazy"
                            src={productdata.ImagePath}
                            title={productdata.ProductName}
                          />
                        </div>
                        <div className="col-md-9">
                          {CONFIG.DATA.BACKEND_HOST === "lewisfood" ? (
                            <div className="list-col4 ">
                              <div className="red-corner-modal">
                                {/*<!-- -->*/}
                              </div>
                              {productdata.PLUCode === "100%" ? (
                                <div className="free-modal corner-text">
                                  <br />
                                  Free!&nbsp;&nbsp;{" "}
                                  <span
                                    style={{
                                      fontSize: "15px",
                                      display: "block",
                                    }}
                                  ></span>
                                </div>
                              ) : (
                                <div className="free-modal corner-text">
                                  Save{" "}
                                  <span
                                    style={{
                                      fontSize: "15px",
                                      display: "block",
                                    }}
                                  >
                                    {productdata.PLUCode}
                                  </span>
                                </div>
                              )}
                            </div>
                          ) : (
                            ""
                          )}

                          <h6
                            className="offer-expires"
                            style={{ color: "red", fontStyle: "italic" }}
                          >
                            Offer Expires on{" "}
                            <Moment unix format={"MM/DD/YYYY"}>
                              {productdata.ExpiresOn
                                ? productdata.ExpiresOn.replace("/", "")
                                    .replace("/", "")
                                    .replace("Date(", "")
                                    .replace(")", "")
                                    .replace("000+0000", "")
                                    .replace(" ", "")
                                : ""}
                            </Moment>
                          </h6>

                          <button
                            onClick={(e) => {
                              this.AddtoCart(e, index);
                            }}
                            rel="nofollow"
                            id={`add_to_cart_${index}`}
                            className="quickview btn btn-theme btn-outline basic-button add_to_cart"
                          >
                            <span
                              id={`span_add_to_cart_${index}`}
                              data-action={
                                productdata.IsInCart ? "remove" : "add"
                              }
                              className="title-cart"
                            >
                              {productdata.IsInCart
                                ? CONFIG.DATA.REMOVE_FROM_CART_TEXT
                                : CONFIG.DATA.ADD_TO_CART_TEXT}
                            </span>
                          </button>

                          <hr />
                          <p style={{ color: "#000000" }}>
                            {productdata.Details}
                          </p>
                        </div>
                      </div>
                    </Modal.Body>
                  </Modal>
                ) : (
                  ""
                )}

                <div
                  className={`coupon-banner-image-container  col-lg-${
                    IsLewisFood ? `12` : `9`
                  } col-md-${IsLewisFood ? `12` : `9`}`}
                >
                  {CONFIG.DATA.BACKEND_HOST === "foodbazaar" ? (
                    <img
                      className="coupon-banner-image mb-5"
                      alt="Digital Coupons. Browser and Add Coupons, Scan Card, and Get Instant Savings"
                      style={{
                        position: "relative",
                        maxWidth: "150%",
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto",
                        width: "auto",
                      }}
                      src={CONFIG.DATA.COUPON_PAGE_TOP_IMAGE}
                    />
                  ) : (
                    <>
                      {!IsLewisFood ? (
                        <div className="banner-data">
                          <img
                            className="coupon-banner-image mb-5"
                            alt="Digital Coupons. Browser and Add Coupons, Scan Card, and Get Instant Savings"
                            style={{
                              width: "100%",
                              objectFit: "cover",
                              maxWidth: "100%",
                              objectFit: "cover",
                            }}
                            src={CONFIG.DATA.COUPON_PAGE_TOP_IMAGE}
                          />
                        </div>
                      ) : (
                        <div className="background"></div>
                      )}
                    </>
                  )}
                  <div className="row">
                    <div
                      className="woocommerce columns-4"
                      style={{ minHeight: "500px" }}
                    >
                      <div className="shop-products row grid-view">
                        {coupanlist && coupanlist.length > 0 ? (
                          <>
                            {coupanlist}
                            <div
                              style={{
                                fontSize: "12px",
                                fontStyle: "italic",
                                padding: "50px 0px 50px 0px",
                              }}
                            >
                              Disclaimer:{" "}
                              {CONFIG.DATA.COUPON_PAGE_DISCLAIMER_TEXT}
                            </div>
                          </>
                        ) : coupanlist && coupanlist.length === 0 ? (
                          <div className="content">
                            <div className="overlay">
                              <div className="overlay-content">
                                <br />
                                <br />
                                <h3>No coupons available</h3>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="content">
                            <div className="overlay">
                              <div className="overlay-content">
                                <img
                                  style={{ maxWidth: "none" }}
                                  src="/assets/images/loading.gif"
                                  alt="Loading..."
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Coupons;
